import { Box, Input, Text } from '@chakra-ui/react'
import React from 'react'
import { Controller } from 'react-hook-form'

export function InputInnovationSelect({ children, ...rest }) {
  return (
    <Box position="relative" {...rest}>
      <Box
        border={`1px solid`}
        borderColor={rest.error ? 'red.500' : '#378BBF'}
        borderRadius="4px"
        h="37px"
        display="flex"
        alignItems="center"
        cursor="pointer"
        bgColor="#fff"
        overflow="hidden"
        {...rest}
      >
        <Box
          color="#378BBF"
          textTransform="uppercase"
          fontWeight="semibold"
          w="100px"
        >
          <Box
            as="label"
            htmlFor={rest.name}
            fontSize="14px"
            border="none"
            p="0"
            w="fit-content"
            fontWeight="semibold"
            ml="10px"
          >
            Cliente:
          </Box>
        </Box>
        <Controller
          control={rest.control}
          name={rest.name}
          defaultValue={rest.defaultValue || ''}
          render={({ field }) => (
            <Input
              {...field}
              id={rest.name}
              border="none"
              fontSize="14px"
              p="0"
              _focus={{ boxShadow: 'none' }}
              _hover={{ boxShadow: 'none' }}
              placeholder="Cod. Cliente, CNPJ/CPF, Email, Nome do Cliente"
            />
          )}
          {...rest}
        />
      </Box>
      {rest.error && (
        <Text fontSize="xs" color="red.500" position="absolute" bottom="-18px">
          {rest.error.message}
        </Text>
      )}
    </Box>
  )
}
